<template>
  <v-container fluid>
    <v-row dense>
      <v-col cols="2">
        Empfangene Nachrichten:
      </v-col>
    </v-row>
    <v-row dense>
      <v-col cols="12">
        <v-data-table
          :headers="messageTable.headers"
          :items="messages"
          item-key="id"
          class="elevation-1"
          :expanded.sync="messageTable.expanded"
          show-expand
          dense
          @click:row="dataTableRowClicked"
          >
          <template v-slot:top>
            <v-container fluid>
              <v-row>
                <v-col cols="2">
                  <OnionRpcFilterButton
                    v-model="config.activeFilter"
                  ></OnionRpcFilterButton>
                </v-col>
                <v-col cols="2">
                </v-col>
                <v-col cols="7">
                </v-col>
                <v-col cols="1">
                  <TooltipBtn
                    icon="mdi-delete"
                    @click="deleteAllMessages()"
                  >
                    Nachrichtentabelle leeren
                  </TooltipBtn>
                </v-col>
              </v-row>
            </v-container>
          </template>
          <template v-slot:expanded-item="{ headers, item }">
            <td :colspan="headers.length">
              <div v-if="item.methodString">
                <b>Method:</b><br><span><ul><li>{{ item.methodString }}</li></ul></span>
              </div>
              <div v-if="item.requestHtmlString && item.requestHtmlString !== '<ul></ul>'">
                <b>Request:</b><br><span v-html="item.requestHtmlString"></span>
              </div>
              <div v-if="item.resultHtmlString && item.resultHtmlString !== '<ul></ul>'">
                <b>Response:</b><br><span v-html="item.resultHtmlString"></span>
              </div>
            </td>
          </template>
        </v-data-table>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import TooltipBtn from '@/components/TooltipBtn.vue';
import OnionRpcFilterButton from '@/components/OnionRpc/OnionRpcFilterButton.vue';

export default {
  props: [
  ],
  emits: [
  ],
  components: {
    OnionRpcFilterButton,
    TooltipBtn,
  },
  data: () => ({
    messages: [],
    config: {
      activeFilter: {
        showEmptyEvents: true,
        activeEventFilters: [],
        activeMethodFilters: [],
      },
      messageListLength: 10,
    },
    messageTable: {
      expanded: [],
      headers: [{
        text: 'Zeitstempel',
        align: 'start',
        sortable: true,
        value: 'timestamp',
      }, {
        text: 'Id',
        align: 'start',
        sortable: true,
        value: 'id',
      }, {
        text: 'Methode',
        align: 'start',
        sortable: true,
        value: 'method',
      }, {
        text: 'Fehler',
        align: 'start',
        sortable: false,
        value: 'errorAsString',
      }, {
        text: 'Erwartet ?',
        align: 'start',
        sortable: false,
        value: 'expectedAsString',
      }, {
        text: 'Request-Data',
        align: 'start',
        sortable: false,
        value: 'requestAsString',
        width: '15%',
      }, {
        text: 'Response-Data',
        align: 'start',
        sortable: false,
        value: 'resultAsString',
        width: '70%',
      }, 
      { text: '', value: 'data-table-expand' },
      ],
    },
  }),

  computed: {
  },

  methods: {
    dataTableRowClicked(item) {
      const idx = this.messageTable.expanded.indexOf(item);
      if (idx >= 0) {
        this.messageTable.expanded.splice(idx, 1);
      } else {
        this.messageTable.expanded.push(item);

      }
    },
    addMessage(message) {
      let messageOfInterest = true;
      const { activeEventFilters, activeMethodFilters, showEmptyEvents } = this.config.activeFilter;
      if (activeMethodFilters.indexOf(message.methodString) < 0) {
        messageOfInterest = false;
      }

      if (messageOfInterest && message.methodString === 'ReadEventBuffer') {
        let containsEventOfInterest = false;
        message.resultObj.elements.forEach((el) => {
          if (el.events) {
            if (el.events.length === 0 && showEmptyEvents) {
              containsEventOfInterest = true;
            }
            el.events.forEach((evt) => {
              const idx = activeEventFilters.indexOf(evt.onionRpcEvent.shortName);
              if (idx >= 0) {
                containsEventOfInterest = true;
              }
            });
          }
        });

        if (!containsEventOfInterest) {
          messageOfInterest = false;
        }
      }
      if (messageOfInterest) {
        this.messages.push(message);
        if (this.messages.length > this.config.messageListLength) {
          this.messages.splice(0, this.messages.length - this.config.messageListLength);
        }
      }
    },
    deleteAllMessages() {
      this.messages.splice(0);
    },
  },

  watch: {
  },

  mounted() {
  },
};
</script>

<style>

</style>